import {
	welcomeImageAtom,
	welcomeImageFileAtom,
} from 'features/generator/contentFormSections'
import { colorSchemeOptionListAtom } from 'features/generator/contentFormSections/client/ContentDesignForm'
import {
	sectionsListAtom,
	TMenuContent,
} from 'features/generator/contentFormSections/MenuForm/MenuForm'
import {
	restaurantDescriptionAtom,
	restaurantImageAtom,
	restaurantImageFileAtom,
	restaurantNameAtom,
} from 'features/generator/contentFormSections/MenuForm/RestaurantInfo'
import { atom } from 'jotai'
import { TUploadedMedia } from 'services/mediaStorage'

import {
	primaryColorAtom,
	secondaryColorAtom,
	selectedColorSchemeAtom,
} from '@/content-from-sections/client'
import { getFileFromMedia, isOnServer } from '@/utils'

import { QR_TYPE } from '../../generatorTypes'

export const emptyImage = {
	publicId: '',
	resourceType: '',
	format: '',
	bytes: 0,
} as TUploadedMedia

const menuContentAtomWithSectionIds = atom<TMenuContent, [TMenuContent], void>(
	(get) => ({
		type: QR_TYPE.Menu,
		colors: {
			primary: get(primaryColorAtom),
			secondary: get(secondaryColorAtom),
		},
		info: {
			name: get(restaurantNameAtom),
			description: get(restaurantDescriptionAtom),
			image: get(restaurantImageAtom) || emptyImage,
		},
		sections: get(sectionsListAtom),
		loaderImage: get(welcomeImageAtom) || emptyImage,
	}),
	(get, set, content: TMenuContent) => {
		// Color scheme
		const colorScheme = get(colorSchemeOptionListAtom).find(
			(scheme) =>
				scheme.primary === content.colors.primary &&
				scheme.secondary === content.colors.secondary,
		)

		set(selectedColorSchemeAtom, colorScheme?.name ?? '')
		set(primaryColorAtom, content.colors.primary)
		set(secondaryColorAtom, content.colors.secondary)

		set(restaurantNameAtom, content.info.name)
		set(restaurantDescriptionAtom, content.info.description)
		set(restaurantImageAtom, content.info.image)
		if (!isOnServer) {
			setTimeout(async () => {
				try {
					const loaderFile = await getFileFromMedia(content.info.image)
					set(restaurantImageFileAtom, loaderFile)
				} catch (error) {
					console.error(error)
				}
			}, 0)
		}
		set(sectionsListAtom, content.sections)
		set(welcomeImageAtom, content.loaderImage)
		if (!isOnServer) {
			setTimeout(async () => {
				try {
					const loaderFile = await getFileFromMedia(content.loaderImage)
					set(welcomeImageFileAtom, loaderFile)
				} catch (error) {
					console.error(error)
				}
			}, 0)
		}
	},
)

export const menuContentAtom = atom(
	(get) => {
		const content = get(menuContentAtomWithSectionIds)
		return {
			...content,
			sections: content.sections.map((section) => {
				const { id: _, products, ...rest } = section

				const productsWithoutId = products.map((product) => {
					const { id: _, localImageUrl: _localUrl, ...rest } = product
					return rest
				})

				return {
					...rest,
					products: productsWithoutId,
				}
			}),
		}
	},
	(get, set, newContent: TMenuContent) => {
		set(menuContentAtomWithSectionIds, newContent)
	},
)
